import { dayNumber, isDateKey } from './bookingDates';
import { weekendNights } from './staySettings';

export function calculateBookingPrice(property, range, hasPet = false) {
  if (!isDateKey(range.start) || !isDateKey(range.end)) return null;
  const start = dayNumber(range.start);
  const end = dayNumber(range.end);
  if (end <= start || !Number.isFinite(property.rates.weekday) || !Number.isFinite(property.rates.weekend)) return null;
  let weekdays = 0;
  let weekends = 0;
  for (let day = start; day < end; day += 1) {
    if (weekendNights.includes(new Date(day * 86400000).getUTCDay())) weekends += 1;
    else weekdays += 1;
  }
  const weekdayTotal = weekdays * property.rates.weekday;
  const weekendTotal = weekends * property.rates.weekend;
  const stayTotal = weekdayTotal + weekendTotal;
  const petFee = hasPet ? property.petFee : 0;
  return { weekdays, weekends, weekdayTotal, weekendTotal, stayTotal, petFee, total: stayTotal + petFee };
}
